import Tooltip from 'bootstrap/js/src/tooltip';

function bindTooltip(el, value) {
    if (el._tooltip) {
        el._tooltip.dispose();
        el._tooltip = null;
    }
    if (!value) {
        return;
    }
    el.dataset.bsToggle = 'tooltip';
    el.setAttribute('title', value);
    el.dataset.bsPlacement = 'top';
    el._tooltip = new Tooltip(el, {
        boundary: document.body,
        container: el.dataset.bsContainer || false,
        customClass: el.dataset.bsCustomClass || '',
    });
}

export default {
    name: 'b-tooltip',
    mounted(el, binding) {
        bindTooltip(el, binding.value);
    },
    updated(el, binding) {
        if (binding.value === binding.oldValue) {
            return;
        }
        bindTooltip(el, binding.value);
    },
    beforeUnmount(el) {
        if (el._tooltip) {
            el._tooltip.dispose();
            el._tooltip = null;
        }
    },
};
